<div class="flex-col height100p">
    <sm-toolbar>
        <input pInputText class="width300" type="text" placeholder="Prozess-ID" [(ngModel)]="processId"/>
        <button pButton icon="fas fa-load" label="Laden" (click)="load()"></button>
        <button *ngIf="p != null" pButton icon="fas fa-arrow" label="Weiterleiten" (click)="forward()"></button>
        <span *ngIf="p != null" class="ml-5">Name: <b>{{p.name}}</b></span>
        <span *ngIf="p != null" class="ml-3">Startdatum: <b>{{p.creationTime | date:'dd.MM.yyyy HH:mm:ss'}}</b></span>
        <span *ngIf="p?.endTime != null" class="ml-3">Enddatum: <b>{{p.endTime | date:'dd.MM.yyyy HH:mm:ss'}}</b></span>
    </sm-toolbar>
    <p-tabView *ngIf="p != null" class="flex-item-fill height100p full-height direct-sub">
        <p-tabPanel header="Variablenbaum">
            <p-treeTable [value]="variablesTree" [style.height]="'700px'">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Name</th>
                        <th>Value</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                    <tr [ttRow]="rowNode" [ttContextMenuRow]="rowNode">
                        <td>
                            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                            {{rowData.key}}
                        </td>
                        <td>{{rowData.value}}</td>
                    </tr>
                </ng-template>
            </p-treeTable>
        </p-tabPanel>
        <p-tabPanel header="Historie">
            <div class="flex-col height100p">
                <sm-toolbar>
                    <p-checkbox class="mr-3" label="Variablen anzeigen" name="showVariables" [(ngModel)]="showVariables" [binary]="true" (ngModelChange)="fillTable()"></p-checkbox>
                    <p-checkbox class="mr-3" label="Variablen entrollen" name="unrollVariables" [(ngModel)]="unrollVariables" [binary]="true" (ngModelChange)="fillTable()"></p-checkbox>
                    <p-checkbox class="mr-3" label="Nur Änderungen anzeigen" name="onlyChanges" [(ngModel)]="onlyChanges" [binary]="true" (ngModelChange)="fillTable()"></p-checkbox>
                    <p-checkbox class="mr-3" label="Änderungen markieren" name="markChanges" [(ngModel)]="markChanges" [binary]="true" (ngModelChange)="fillTable()"></p-checkbox>
                    <p-checkbox class="mr-3" label="Nur Benutzer-Aktivitäten" name="onlyUserActivities" [(ngModel)]="onlyUserActivities" [binary]="true" (ngModelChange)="fillTable()"></p-checkbox>
                </sm-toolbar>
                <sm-table2 [data]="historyTable" class="flex-item-fill height100p" (onCellValueChanged)="cellEdited($event)">
                </sm-table2>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>
